<template>
  <v-container>
    <v-row>
      <v-col
        cols="4"
        md="2"
      >
        <b>Contact name:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ contact_name }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Phone Number:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ phone_number }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Email:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ email }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Line:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ line_id }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Contact',
  props: ['contact_name', 'phone_number', 'email', 'line_id']
}
</script>
